import { ReactionType } from '../model/post.types';

const REACTION_EMOJI: Record<ReactionType, string> = {
  CheckMark: '✅',
  Clap: '👏',
  Comment: '💬',
  Cry: '😭',
  Disappointed: '😔',
  ExplodingHead: '🤯',
  Eyes: '👀',
  FaceHearts: '🥰',
  Fire: '🔥',
  Fist: '👊',
  Goat: '🐐',
  Heart: '❤️',
  HeartEyes: '😍',
  Horns: '🤟',
  Hug: '🤗',
  Joy: '😂',
  Muscle: '💪',
  OpenMouth: '😮',
  Pray: '🙏',
  RaisedHands: '🙌',
  Relieved: '😌',
  Rocket: '🚀',
  Skull: '💀',
  Sparkles: '✨',
  SweatSmile: '😅',
  Tada: '🎉',
  Tear: '🥲',
  ThumbsUp: '👍',
  Trophy: '🏆',
};

export const reactionEmoji = (type: ReactionType): string =>
  REACTION_EMOJI[type];
